var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.424 22.5h-5.052v-7.388c0-1.929-.788-3.247-2.526-3.247-1.328 0-2.066.889-2.41 1.75-.131.304-.11.736-.11 1.161V22.5H8.324s.066-13.077 0-14.266h5.002v2.236c.296-.977 1.894-2.373 4.446-2.373 3.164 0 5.652 2.051 5.652 6.47V22.5ZM3.266 6.45h-.033C1.622 6.45.576 5.358.576 3.975.576 2.57 1.652 1.5 3.297 1.5c1.642 0 2.652 1.066 2.685 2.473 0 1.382-1.043 2.476-2.716 2.476v.001ZM1.151 8.234h4.455V22.5H1.151V8.234Z",
    fill: "currentColor"
  })));
};
export default SvgLinkedin;